"use strict";

angular.module("licensure.services").factory("Statuses", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/Statuses", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
            getProcessStatuses: function (ProcessID) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Statuses', {
                        params: {
                            ProcessID: ProcessID
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
